export const getPaxCount = (config, isPaxCount = false) => {
	if (!config) return ''

	let sum = config.reduce(
		(acc, room) => ({
			adultCount: acc?.adultCount + room?.adultCount,
			childCount: acc?.childCount + room?.childAges?.length,
		}),
		{
			adultCount: 0,
			childCount: 0,
		},
	)
	return isPaxCount
		? sum?.adultCount + sum?.childCount
		: `${sum?.adultCount} adult${sum?.adultCount > 1 ? 's' : ''} ${
				sum?.childCount > 0
					? `, ${sum?.childCount} ${
							sum?.childCount > 1 ? ' children' : ' child'
					  }`
					: ''
		  }`
}
